@if (track.isOK) {
  <div class="track-section-in-cart__text">
    <p
      class="track-section-in-cart__text-price"
      [ngClass]="{
        'theme-cartPopup__beatPrice': parentComponent === 'track-in-cart-popUp',
        'theme-cartPage__beatPrice': parentComponent === 'track-item',
        'theme-cartPopup__discountPrice': parentComponent === 'track-in-cart-popUp' && track.hasDiscount,
        'theme-cartPage__discountPrice': parentComponent === 'track-item' && track.hasDiscount,
        'track-section-in-cart__text-price--without-discount': track.hasDiscount
      }"
    >
      {{ track.fullPrice }} {{ currencySign }}
    </p>
    @if (track.hasDiscount) {
      <p
        class="track-section-in-cart__text-price"
        [ngClass]="{
          'theme-cartPopup__beatPrice': parentComponent === 'track-in-cart-popUp',
          'theme-cartPage__beatPrice': parentComponent === 'track-item'
        }"
      >
        / {{ track.priceWithDiscount }} {{ currencySign }}
      </p>
    }
  </div>
}

<div class="track-section-in-cart__icons">
  @if (checkIsShowEditIcon(track)) {
    <div
      class="btv-icon-edit"
      [ngClass]="{
        'theme-cartPopup__editLicenseIcon': parentComponent === 'track-in-cart-popUp',
        'theme-cartPage__editLicenseIcon': parentComponent === 'track-item'
      }"
      (click)="changeLicense($event, track.id, track.licenseId)"
    ></div>
  }
  <div
    class="btv-icon-delete"
    (click)="deleteTrackFromCart(track.id)"
    [ngClass]="{
      'theme-cartPopup__deleteBeatIcon': parentComponent === 'track-in-cart-popUp',
      'theme-cartPage__deleteBeatIcon': parentComponent === 'track-item'
    }"
  ></div>
</div>
